import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  TrainingGroupTrainingRequirementAudit,
  TrainingGroupTrainingRequirementSkeleton
} from '../../../+models/training-requirement-audit.model';

@Component({
  selector: 'sd-portal-training-group-training-requirement-audit-list',
  templateUrl: './training-group-training-requirement-audit-list.component.html',
  styleUrls: ['./training-group-training-requirement-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainingGroupTrainingRequirementAuditListComponent implements OnInit {
  @Input() trainingGroupTrainingRequirementSkeletons: TrainingGroupTrainingRequirementSkeleton[];
  @Input() trainingGroupTrainingRequirementAuditLoading: boolean;
  @Input() trainingGroupTrainingRequirementAudits: TrainingGroupTrainingRequirementAudit[];

  @Output() opened = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onOpened(trainingGroupTrainingRequirementId: number) {
    this.opened.emit(trainingGroupTrainingRequirementId);
  }

  onNextPage(trainingGroupTrainingRequirementId: number) {
    this.nextPage.emit(trainingGroupTrainingRequirementId);
  }
}
